
import axios from "axios";
import Oauth from "oauth-1.0a";
import CryptoJS from "crypto-js";
import jQuery from "jquery";
import Cookies from "universal-cookie";
import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

// WooCommerce API credentials
const ck = "ck_13df3a3f223ec185f4f8474b549eb71dc034a24c";
const cs = "cs_100eb7a677b455190b839717f1bbef4a0d0e262e";
const baseURL = "https://www.muktaofficial.com/wp-json";

// WooCommerce REST API client
const WooCommerce = new WooCommerceRestApi({
  url: "https://www.muktaofficial.com",
  consumerKey: ck,
  consumerSecret: cs,
  version: "wc/v3",
});

const prefix = "/wc/v3/";

export const Wordpress = {
  login: (data) => {
    return axios.post("https://www.muktaofficial.com/wp-json/jwt-auth/v1/token", data);
  },

  authenticate: (data) => {
    return axios.post("https://www.muktaofficial.com/wp-json/jwt-auth/v1/token", data);
  },

  validateJwth: () => {
    const token = localStorage.getItem("token");
    if (!token) return Promise.reject("No token found");

    return axios.post("https://www.muktaofficial.com/wp-json/jwt-auth/v1/token/validate", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

logout: () => {
  localStorage.removeItem("token");
  const cookies = new Cookies();
  cookies.remove("token");
}
};

export const Woocommerce = {
  getProducts: (page) => makeRequest(prefix + "products", page),
  getProductByID: (id) => makeRequest(prefix + "products/" + id),
  getCategoriesList: () => makeRequest(prefix + "products/categories", { per_page: 100 }),
  getPaymentGateway: () => makeRequest(prefix + "payment_gateways"),
  getCustomerList: (params) => makeRequest(prefix + "customers", params),
  getCountryList: () => makeRequest(prefix + "data/countries"),
  getStateList: () => makeRequest(prefix + "data/countries/bd"),
  postOrder: (data) => makePostRequest(prefix + "orders", data),
  postCustomer: (data) => makePostRequest(prefix + "customers", data),
  getSpecificCustomer: (id) => makeRequest(prefix + "customers/" + id),
  updateOrder: (id, data) => WooCommerce.put("orders/" + id, data),
  getAllData: () => makeRequest(prefix + "data"),
  getProductVariation: (id, params) => makeRequest(prefix + "products/" + id + "/variations", params),
  postOrderNote: (id, data) => makePostRequest(prefix + "orders/" + id + "/notes", data),
  getOrderHistory: (params) => makeRequest(prefix + "orders", params),
  getTaxList: () => makeRequest(prefix + "taxes"),
  getSumoList: (params) => makeRequest(prefix + "coupons", params),
  changePosStatus: (id, data) => {},
};

function makeRequest(endpoint, data = {}, method = "GET") {
  const oauth = getOauth();
  const requestData = {
    url: baseURL + endpoint,
    method,
    data,
  };
  const requestURL = requestData.url + "?" + jQuery.param(oauth.authorize(requestData));
  return axios.get(requestURL);
}

function makePostRequest(endpoint, data = {}, method = "POST") {
  return axios({
    method,
    url: baseURL + endpoint,
    data,
    auth: {
      username: ck,
      password: cs,
    },
  });
}

function getOauth() {
  return Oauth({
    consumer: {
      key: ck,
      secret: cs,
    },
    signature_method: "HMAC-SHA1",
    hash_function: function (base_string, key) {
      return CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA1(base_string, key));
    },
  });
}
